import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  selectDoesUserHaveRbacPermission,
  selectIsProductRecommendationsFeatureFlagOn,
} from 'core/userContext/selectors';
import { changeCollectionDetails } from 'modules/catalog/collectionBuilder/actions';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import {
  closeDeleteModal,
  deleteCatalogCollection,
  fetchCatalogCollections,
  openDeleteModal,
  openHandlebarsModal,
  setUsesSmartRecosHandlebar,
} from '../actions';
import {
  selectFetchParams,
  selectIsDeleteModalOpen,
  selectIsFetchingCollections,
  selectCollections,
  selectSelectedCollection,
  selectTotalCollections,
} from '../selectors';
import Collections from './Collections';

class CollectionsContainer extends React.Component {
  /**
   * componentDidMount
   * Fetches data when collections component mounts.
   * @return { void }
   */
  componentDidMount() {
    this.props.fetchCatalogCollections();
  }

  render() {
    return <Collections {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  canManageCatalogs: selectDoesUserHaveRbacPermission(state)(PROJECT_PERMISSIONS.ManageCatalogs),
  collections: selectCollections(state),
  fetchParams: selectFetchParams(state),
  isDeleteModalOpen: selectIsDeleteModalOpen(state),
  isFetchingCollections: selectIsFetchingCollections(state),
  isProductRecommendationsOn: selectIsProductRecommendationsFeatureFlagOn(state),
  selectedCollection: selectSelectedCollection(state),
  total: selectTotalCollections(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeCollectionDetails,
      closeDeleteModal,
      deleteCatalogCollection,
      fetchCatalogCollections,
      openDeleteModal,
      openHandlebarsModal,
      setUsesSmartRecosHandlebar,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionsContainer));
